export const FETCH_ADDRESS = {
  START: 'FETCH_ADDRESS_START',
  SUCCESS: 'FETCH_ADDRESS_SUCCESS',
  ERROR: 'FETCH_ADDRESS_ERROR',
};

export const SAVE_ADDRESS = {
  START: 'SAVE_ADDRESS_START',
  SUCCESS: 'SAVE_ADDRESS_SUCCESS',
  ERROR: 'SAVE_ADDRESS_ERROR',
};

export const FETCH_ADDRESS_TYPES = {
  START: 'FETCH_ADDRESS_TYPES_START',
  SUCCESS: 'FETCH_ADDRESS_TYPES_SUCCESS',
  ERROR: 'FETCH_ADDRESS_ERROR',
};
